<template>
    <popup-modal ref="popup">
        <h2 class="font-bold mb-4 text-xl">{{ title }}</h2>
        <div class="mb-4">{{ message }}</div>
        <textarea ref="reason" class="w-full h-20 input mb-4 focus:outline-none bg-white/10" autofocus></textarea>
        <div class="flex items-center justify-between">
            <button class="btn btn-md" @click.prevent="_cancel">{{ cancelButton }}</button>
            <button class="btn btn-md btn-primary" @click.prevent="_confirm">{{ okButton }}</button>
        </div>
    </popup-modal>
</template>
<script>
import PopupModal from './PopupModal.vue'
import Textarea from "../form/textarea";

export default {
	name: 'ConfirmReasonDialog',

	components: {Textarea, PopupModal},

	data: () => ({
		title: undefined,
		message: undefined, // Main text content
		okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
		cancelButton: 'Отмена', // text for cancel button
		isPrompt: false,

		resolvePromise: undefined,
		rejectPromise: undefined,
	}),

	methods: {
		show(opts = {}) {
			this.title = opts.title
			this.message = opts.message
			this.okButton = opts.okButton
			this.isPrompt = opts.isPrompt ?? false;

			if (opts.cancelButton) {
				this.cancelButton = opts.cancelButton
			}

			this.$refs.popup.open();

			setTimeout(() => {
				this.$refs.reason.focus();
			}, 100);

			return new Promise((resolve, reject) => {
				this.resolvePromise = resolve
				this.rejectPromise = reject
			})
		},

		_confirm() {
			this.$refs.popup.close()
			this.resolvePromise(this.$refs.reason.value ?? null)
		},

		_cancel() {
			this.$refs.popup.close()
			this.rejectPromise()
		},
	},
}
</script>